import { render, staticRenderFns } from "./anchor-item.vue?vue&type=template&id=2f090403&scoped=true"
import script from "./anchor-item.vue?vue&type=script&lang=js"
export * from "./anchor-item.vue?vue&type=script&lang=js"
import style0 from "./anchor-item.vue?vue&type=style&index=0&id=2f090403&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f090403",
  null
  
)

export default component.exports